<template>
    <div>
        <hr>
    </div>

</template>
<style scoped>
 hr{ margin-top:0;}
/* p { font-weight:bold; } */
</style>
<script>
export default {
  props: ['value','config'],

  data(){
    return {
    }
  },

}
</script>
